import { createContext } from 'react';
export const defaultContext = {
    size: 'medium',
};
export const ShortTextPickerContext = createContext(defaultContext);
